import { BaSeButton, BaSeCheckbox, BaSeIcon } from "@base/react";
import { useEffect, useState } from "react";
import {eventTag} from "../../../services/utils";

const CreatePlanningBanner = ({
  isCollapsed,
  setIsCollapsed,
  planningList,
  handleCreatePlanning,
  showInformationBox,
  eventLabGA,
}) => {
  const [selectedPlannings, setSelectedPlannings] = useState([]);
  
  useEffect(() => {
    const validPlanningIds = planningList.map(planning => planning.plan_id);
    setSelectedPlannings(prevSelected => prevSelected.filter(id => validPlanningIds.includes(id)));
  }, [planningList]);

  return (
    <div
      className={`information-box ${isCollapsed ? "collapsed" : ""}`}
    >
      <div className="information-box-header">
        <h4>Crie um novo planejamento.</h4>
        {/* <BaSeIcon
          color="#2E5DE6"
          description="Fechar informações"
          name="close"
          onClick={() => setIsCollapsed(true)}
          size={16}
        /> */}
      </div>
      <div className="information-box-texts">
        <small>
          Percebemos que você criou vários cenários. Agora você pode eleger um preferido com esses novos indicadores.
        </small>
        <small>
          Qual deles você gostaria de transformar em um novo planejamento?
        </small>
      </div>
      <div className="information-box-planning-list">
        {planningList.map((planning) => {
          return (
            <div className="information-box-planning" key={planning.plan_id}>
              <BaSeCheckbox
                label={planning.nome}
                id={planning.plan_id}
                shape="circle"
                onChange={() => {
                  setSelectedPlannings(prevSelected => {
                    if (prevSelected.includes(planning.plan_id)) {
                      return prevSelected.filter(id => id !== planning.plan_id);
                    } else {
                      return [...prevSelected, planning.plan_id];
                    }
                  });
                }}
                checked={selectedPlannings.includes(planning.plan_id)}
              />
            </div>
          )
        })}
      </div>
      {selectedPlannings.length > 3 && <p className="danger-text no-margin">Selecione <strong>até 3</strong> planejamentos</p>}
      <small>Fique tranquilo, seu planejamento original continua intacto.</small>
      <div className="information-box-footer">
        <BaSeButton
          color="#2E5DE6"
          value="Criar novo planejamento"
          isDisabled={!showInformationBox && (selectedPlannings.length === 0 || selectedPlannings.length > 3)}
          onClick={() => {
            handleCreatePlanning(selectedPlannings)
            eventTag(eventLabGA?.name, eventLabGA?.category, eventLabGA?.action, "Criar novo planejamento")
          }}
        />
      </div>
    </div>
  )
}

export default CreatePlanningBanner;
